import { WithTestIdOptional } from '../test';
import { DisplayPrice } from './display-price';

/** Render props for ProductPricing */
export interface ProductPricingProps extends WithTestIdOptional {
	/**
	 * The pricing object to render. This should typically come from the display pricing service.
	 */
	displayPrice: DisplayPrice | undefined | null;

	/**
	 * The custom CSS class name for custom styling
	 */
	className?: string;

	/**
	 * Determines whether the prices are displayed inline or not.
	 */
	inline?: boolean;
}

type CssClass = (string | {} | null)[];

export interface CssClasses {
	/** Shared CSS for the entire display price */
	base: CssClass;
	/** Price for a product that isn't on sale */
	normalPrice: CssClass;
	/** Crossed out because something is on sale */
	crossedOutPrice: CssClass;
	/** Bright and highlighted on sale price */
	highlightedPrice: CssClass;
}

export enum UnitOfMass {
	kg = 'kg',
	lbs = 'lbs',
	oz = 'oz',
}

export enum UnitOfLength {
	inch = 'Inch',
	cm = 'Centimeter',
}

export enum ProductType {
	Simple = 'Simple',
	Group = 'Group',
	// TODO: kits
	// Kit = 'Kit',
	// TODO: gift cards
	// GiftCard = 'Gift Card',
}
